import React from "react";
import ReactDOM from "react-dom";
import "./ReactotronConfig";
import * as Sentry from "@sentry/browser";
import config from "./config";

if (
  process.env.REACT_APP_STAGE === "dev" ||
  process.env.REACT_APP_STAGE === "prod"
) {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    release: process.env.REACT_APP_RELEASE_NAME,
    environment: process.env.REACT_APP_STAGE,
    debug: true 
  });
}

// Save a reference to the root element for reuse
const rootEl = document.getElementById("root");
// Create a reusable render method that we can call more than once
let render = () => {
  // Dynamically import our main App component, and render it
  const MainApp = require("./App").default;
  ReactDOM.render(<MainApp />, rootEl);
};

if (module.hot) {
  module.hot.accept("./App", () => {
    const NextApp = require("./App").default;
    render(<NextApp />, rootEl);
  });
}

render();
